import styled from "styled-components";

import { Container } from "@/components/Atoms/Box";

export const RecipeContainer = styled(Container)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 16px;
  row-gap: 40px;
  padding: 80px 40px;
  width: 100%;

  @media (max-width: 1080px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 780px) {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 20px;
    column-gap: 16px;
    padding: 38px 30px;
  }

  @media (max-width: 650px) {
    grid-template-columns: repeat(1, 1fr);
    row-gap: 16px;
    column-gap: 0px;
    padding: 32px 16px;
  }
`;
